import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PapiDeviation, PapiExtendedDeviation } from '@wix/da-papi-types';
import { makeInitDeviationXHRCall } from '../../simpleXHR/actionCreators';
import { getInitDeviationXHRCallResult } from '../../simpleXHR/selectors';

export const useExtendedDeviation = (
  initialDeviation: PapiDeviation,
  requiredProperty?: keyof PapiExtendedDeviation
) => {
  const isAlreadyExtended = requiredProperty
    ? !!initialDeviation.extended?.[requiredProperty]
    : !!initialDeviation.extended;
  const dispatch = useDispatch();
  const { deviation: extendedDeviation } =
    useSelector(getInitDeviationXHRCallResult) || {};

  useEffect(() => {
    if (isAlreadyExtended) {
      return;
    }
    dispatch(makeInitDeviationXHRCall(initialDeviation));
  }, [dispatch, isAlreadyExtended, initialDeviation]);

  return isAlreadyExtended
    ? initialDeviation
    : extendedDeviation?.deviationId === initialDeviation.deviationId
      ? // avoid returning extended deviation from previous XHR call
        extendedDeviation
      : undefined;
};

export default useExtendedDeviation;
